import { translate } from '../../utils';
import { PortfolioNotice } from './PortfolioNotice';

/** @param {{ notices: import('./portfolioDashboard.types').PortfolioNotice[] }} props */
export const PortfolioNotices = function PortfolioNotices({ notices }) {
    return (
        <div className="box box-solid mb-0">
            <div className="box-header">
                <h3 className="box-title">
                    {translate('frontend', 'DASHBOARD_NOTICES')}
                </h3>
            </div>

            <div className="box-body">
                {notices.length === 0 ? (
                    <p className="my-5 text-center text-muted">{translate('frontend', 'PORTFOLIO_DASHBOARD_NO_NOTICES')}</p>
                ) : (
                    <div className="last-mb-0">
                        {notices.map((notice) => (
                            <PortfolioNotice
                                key={notice.noticeType}
                                notice={notice}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};
